"use client";
import { useRouter } from "next/navigation";
import { useCurrentLocale } from "./useCurrentLocale";
import { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";

export default function useLocaleRouter() {
  const locale = useCurrentLocale();

  const router = useRouter();

  const localePrefix = locale === "cn" ? "" : `/${locale}`;

  const push = (href: string, options?: NavigateOptions) =>
    router.push(`${localePrefix}${href}`, options);

  const replace = (href: string, options?: NavigateOptions) =>
    router.replace(`${localePrefix}${href}`, options);

  return {
    ...router,
    push,
    replace,
    locale,
    originalPush: router.push,
    originalReplace: router.replace,
  };
}
